import { useState } from 'react'
import { Hotspot, HotspotLegend } from './components/Hotspot'
// import IA_SVG from '../../assets/ia-graphic.svg'
import IA_PNG from '../../assets/ia-graphic.png'
import IA_JPEG from '../../assets/ia-graphic.jpeg'
import IA_PNG_IIOT from '../../assets/ia-graphic-iiot.png'
import IA_JPEG_IIOT from '../../assets/ia-graphic-iiot.jpg'
import './IAVisual.scss'

import content from '../content.json'

export function IAVisual(props) {
    const [active, setActive] = useState('')

    const onSelection = (selection) => {
        setActive(selection)
    }

    const closeOverlay = () => {
        setActive('')
    }
    
    

    return (
        <div className="ia-graphic-wrapper">
            <div className="ia-graphic">
                {active !== '' ? (
                    <div onClick={closeOverlay} id="overlay"></div>
                ) : null}
                <img
                    alt="IA graphic"
                    className="lg-image"
                    src={IA_JPEG_IIOT}
                />
                {/* 1 */}
                <Hotspot
                    top="37.5%"
                    left="15%"
                    content={content.ControlPanelSolutions}
                    onSelection={onSelection}
                    isLit={props.ControlPanelSolutions}
                   
                />
                {/* 2 */}
                <Hotspot
                    top= "35%"
                    left= "49%"
                    content={content.IndustrialComputing}
                    onSelection={onSelection}
                    isLit={props.IndustrialComputing}
                />
                {/* 3 */}
                <Hotspot
                    top= "67.4%"
                    left= "52.7%"
                    content={content.MachineSafety}
                    onSelection={onSelection}
                    isLit={props.MachineSafety}
                />
                {/* 4 */}
                <Hotspot
                    top="35.5%"
                    left="35.6%"
                    content={content.MotionControls}
                    onSelection={onSelection}
                    isLit={props.MotionControls}
                />
                {/* 5 */}
                <Hotspot
                    top="15.9%"
                    left="26%"
                    content={content.Networking}
                    onSelection={onSelection}
                    isLit={props.Networking}
                />
                {/* 6 */}
                <Hotspot
                    top="54.3%"
                    left="22.3%"
                    content={content.OperatorInterface}
                    onSelection={onSelection}
                    isLit={props.OperatorInterface}
                />
                {/* 7 */}
                <Hotspot
                    top="59.2%"
                    left="33.7%"
                    content={content.PowerMonitoring}
                    onSelection={onSelection}
                    isLit={props.PowerMonitoring}
                />
                {/* 8 */}
                <Hotspot
                    top="31.3%"
                    left="74.2%"
                    content={content.Sensors}
                    onSelection={onSelection}
                    isLit={props.Sensors}
                />
                {/* 9 */}
                <Hotspot
                    top="10%"
                    left="65%"
                    content={content.Cybersecurity}
                    onSelection={onSelection}
                    isLit={props.Cybersecurity}
                />
                {/* 10 */}
                <Hotspot
                    top="9%"
                    left="43.7%"
                    content={content.Pneumatics}
                    onSelection={onSelection}
                    isLit={props.Pneumatics}
                />
                {/* 11 */}
                <Hotspot
                    top="39.1%"
                    left="61.4%"
                    content={content.IIotSolutions}
                    onSelection={onSelection}
                    isLit={props.IIotSolutions}
                />
                {/* 12 */}
                <Hotspot
                    top="46.9%"
                    left="46.5%"
                    content={content.Drives}
                    onSelection={onSelection}
                    isLit={props.Drives}
                />
            </div>
            <div class="grid-4-columns">
                <div class="grid-item">
                    <HotspotLegend
                    content={content.ControlPanelSolutions}
                    onSelection={onSelection}
                    />
                    <h2> Control Panel Solutions </h2>
                </div>
                <div class="grid-item">
                    <HotspotLegend
                        content={content.IndustrialComputing}
                        onSelection={onSelection}
                    />
                    <h2> Industrial Computing</h2>
                </div>
                <div class="grid-item">
                    <HotspotLegend
                        content={content.MachineSafety}
                        onSelection={onSelection}
                    />
                    <h2> Machine Safety </h2>
                </div>
                <div class="grid-item">
                    <HotspotLegend
                        content={content.MotionControls}
                        onSelection={onSelection}
                    />
                    <h2> Motion Controls</h2>
                </div>

                <div class="grid-item">
                    <HotspotLegend
                        content={content.Networking}
                        onSelection={onSelection}
                    />
                    <h2> Networking</h2>
                </div>
                <div class="grid-item">
                    <HotspotLegend
                        content={content.OperatorInterface}
                        onSelection={onSelection}
                    />
                    <h2>Operator Interface + HMI</h2>
                </div>
                <div class="grid-item">
                    <HotspotLegend
                        content={content.PowerMonitoring}
                        onSelection={onSelection}
                    />
                    <h2> Power Monitoring</h2>
                </div>
                <div class="grid-item">
                    <HotspotLegend
                        content={content.Sensors}
                        onSelection={onSelection}
                    />
                    <h2> Sensors</h2>
                </div>
                <div class="grid-item">
                    <HotspotLegend
                        content={content.Cybersecurity}
                        onSelection={onSelection}
                    />
                    <h2> Cybersecurity</h2>
                </div>
                <div class="grid-item">
                    <HotspotLegend
                        content={content.Pneumatics}
                        onSelection={onSelection}
                    />
                    <h2> Pneumatics</h2>
                </div>
                <div class="grid-item">
                    <HotspotLegend
                        content={content.IIotSolutions}
                        onSelection={onSelection}
                    />
                    <h2> Industrial Internet of Things</h2>
                </div>
                <div class="grid-item">
                    <HotspotLegend
                        content={content.Drives}
                        onSelection={onSelection}
                    />
                    <h2> Drives</h2>
                </div>
            </div>
        </div>
    )
}
